import React, { Component} from 'react';
import { translate } from 'react-i18next';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';

var Config = require('../../../config');
const genders = ["HOMBRE","MUJER"];

class PersonData extends Component{
	constructor(props, context) {

		super(props, context);
	    this.searchPerson = this.searchPerson.bind(this);
	    this.closeSearchFingerprint = this.closeSearchFingerprint.bind(this);
		this.availableEdit = this.availableEdit.bind(this);
		this.setNationalCenter = this.setNationalCenter.bind(this);
		
	    //Definicion de variables
	    this.state = { 
			civil_status_array:[],
			documents:[],
			scholarships:[],
	    	jobProfiles:[],
			date:{},
	    	searchText: '',
	    	value:"",

	    	requestedSelected:[],
	    	indice:-1,

			isLoading: false,
			national_centers:[],
			index:-1,
			load_national:false,
			national_selected:[]
	    }
	}

	//Consulta de servicios necesarios para la pantalla
	componentDidMount() {
		this.props.onRef(this);

		fetch(Config.default.apiGateway.URL+'national_centers?option=active',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response !== undefined){
				this.setState({
					national_centers: response
				});

				if(this.props.state.recurrent_center_id !== ""){
					this.setNationalCenter(this.props.state.recurrent_center_id);
				}
			}
			
		})

		fetch(Config.default.apiGateway.URL+'lookups?type=document_type&notrender=0',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      documents: response
		    });
		})

		//llamada a servicio de escolaridad
		fetch(Config.default.apiGateway.URL+'lookups?type=SCHOOLING&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      scholarships: response
		    });
		})

		fetch(Config.default.apiGateway.URL+'lookups?type=CIVIL_STATUS&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       	'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
		  	this.setState({
		      civil_status_array: response
		    });
		})	

		//llamada a servicio de ocupacion
		fetch(Config.default.apiGateway.URL+'lookups?type=profession&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       	'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
		  	this.setState({
		      jobProfiles: response
		    });

		    //console.log(this.props.state.job_profile)
		})	
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	searchPerson(){
		if (this.props.state.document_number !== "" && this.props.state.document_type !== "") {
			fetch(Config.default.apiGateway.URL+'person?number='+this.props.state.document_number+'&type='+this.props.state.document_type,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			        'Content-Type': 'application/json',
			    })
			})
			.then(response => response.json())
			.then(response => {
				/*this.setState({
			      documents: response
			    });*/
			})
		};
	}

	_handleSearchJob = (query) => {
		
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
			if(name === 'recurrent_center_id'){
				this.setState({
					index:0,
					national_selected:values,
				});
				this.props.autocompleteHandle(name, values[0].national_center.id);
			}else{
				this.setState({
					indice:0,
					requestedSelected:values,
				});
				this.props.autocompleteHandle(name,values[0].key);
			}
        	
        	
        }else if(this.state.requestedSelected.length > 0){
        	this.setState({
        		requestedSelected:[]
        	});
        }else if(this.state.national_selected.length > 0){
        	this.setState({
        		national_selected:[]
        	});
        }
	}
	
	clearSearch(){
		this.refs._handleSearch_job._instance.getInstance().clear();
		this.setState({requestedSelected:[]});
	}

	setNationalCenter(center){
		for (var i = 0; i < this.state.national_centers.length; i++) {
				
			if (this.state.national_centers[i].national_center.id === center) {
				this.setState({
					index:i,
					national_selected: [this.state.national_centers[i]],
				});
				break;
			}
		}
	}

    setJobProfile(profile){

    	for (var i = 0; i < this.state.jobProfiles.length; i++) {
				
			if (this.state.jobProfiles[i].key === profile) {
				this.setState({
					indice:i,
					requestedSelected: [this.state.jobProfiles[i]],
				});
				break;
			}
		}	
    }

	searchByFingerprint(e){
		e.preventDefault();
		this.modal_search_fingerprint.handleShow();
	}

	closeSearchFingerprint(res){
		this.props.setInfoDonor(res);
	}

	autoHandleChange = (name,chosenRequest,event,index,value) => {
		this.props.setInfoDonor(chosenRequest)
	}

	availableEdit(e){
		this.props.autocompleteHandle('blockFields',!e.target.checked);
	}

	render(){
		const { t } = this.props;
		return(
			<div className="col-xs-12" style={{padding:"0px"}}>
				<fieldset >
					<legend>Datos del Donador</legend>
						{this.props.state.checkEditData?
						<div className="col-xs-12">
							<input className="form-check-input" type="checkbox" name="blockFields" onKeyPress={(e) => this.props.validate(e)}
					        		value={ this.props.state.blockFields} onChange={ this.availableEdit } style={{marginRight:'5px'}}/>
				        	<span className="span-min">Editar Datos</span>
					    </div>
					    :null}

						<div className="col-xs-12" style={{padding:0}}>
							<div className="col-xs-12 col-sm-4">
								<div className="col-xs-12" style={{padding:0}}>
									<span className="span-min">Ha usted donado sangre en los ultimos 2 años</span>
								</div>
								<div className="col-xs-12 col-sm-6" style={{paddingLeft:0}}>
									<select className="form-control" onKeyPress={(e)=>this.props.validate(e)}
										name="recurrent" id="recurrent" disabled={this.props.state.blockFields}
										value={this.props.state.recurrent}
										onChange={ this.props.selectFieldHandle.bind(null,"id","recurrent") }
									>
										<option value={true}>Si</option>
										<option value={false}>No</option>
									</select>
								</div>								
							</div>
							{this.props.state.recurrent &&
								<div className="col-xs-12 col-sm-4">
									<span className="span-min">Banco de sangre</span>	
									<AsyncTypeahead 
										/*{...this.state}*/
										disabled={this.props.state.blockFields}
										labelKey={(option) => `${option.national_center.name}`}
										minLength={0}
										id="recurrent_center_id" name="recurrent_center_id"
										onKeyPress={(e) => this.props.validate(e)}
										options={this.state.national_centers}
										onChange={this.handleTypeAheadChange('recurrent_center_id')}
										onSearch={this._handleSearchJob}
										defaultSelected={this.state.national_centers.slice(this.state.index, 1)}
										selected={this.state.national_selected}
										ref="_handleNational_center"
										useCache={false}	
										isLoading={this.state.load_national}
										delay={600}
										paginationText="Mostrar mas resultados..."
									/>	
								</div>
							}
						</div>

						<div className="col-xs-12" style={{padding:"0px"}}>
							<div className="col-xs-12 col-sm-2" >
					 			<span className="span-min">{t('content.offers.form.document_type')}</span>
									
					            <select className="form-control" onKeyPress={(e) => this.props.validate(e)}
									name="document_type" id="document_type" disabled={this.props.state.blockFields}
							        value={ this.props.state.document_type || ""} 
							        onChange={ this.props.selectFieldHandle.bind(null,"id","document_type") }
							        > 
							        <option value="" disabled>Seleccionar...</option>
					                {
						                this.state.documents.map(function(t) {
						                  return <option key={t.id}  value={t.key} >{t.name} </option>;
						                })
						            }
				                
				              	</select>

							</div>
							<div className="col-xs-12 col-sm-2" >
								<span className="span-min">{t('content.offers.form.number')}</span>
					        	<input disabled={this.props.state.blockFields} className="form-control" 
									name="document_number" id="document_number" value={ this.props.state.document_number || "" } 
						            onChange={ this.props.handleChange } onKeyPress={(e) => this.props.validate(e)} />
							</div>
							<div className="col-xs-12 col-sm-2" >
								<span className="span-min">{t('content.offers.form.gender')}</span>
					            <select className="form-control" id="sex" name="sex" value={ this.props.state.sex } 
							        onChange={ this.props.selectFieldHandle.bind(null,"id","sex") } onKeyPress={(e) => this.props.validate(e)}
							        disabled={this.props.state.blockFields}> 
							        <option value="" disabled>Seleccionar...</option>
					                {
						                genders.map(function(t) {
						                  return <option key={t}  value={t} >{t} </option>;
						                })
						            }
				              	</select>
							</div>
							
							<div className=" col-xs-12 col-sm-2" >
								<span className="span-min">{t('content.offers.form.civil_status')}</span>
					            <select className="form-control" disabled={this.props.state.blockFields}
									name="civil_status" id="civil_status" value={ this.props.state.civil_status } 
							        onChange={ this.props.selectFieldHandle.bind(null,"id","civil_status") }
							        onKeyPress={(e) => this.props.validate(e)}
							        > 
							        <option value="" disabled>Seleccionar...</option>
					                {
						                this.state.civil_status_array.map(function(t) {

						                  return <option key={t.id}  value={t.key} >{t.name} </option>;
						                })
						            }
				              	</select>
					        </div>

							<div className=" col-xs-12 col-sm-4" style={{paddingLeft: 0}}>
								<div className="form-group col-xs-12 col-sm-8" style={{marginBottom: 0}}>
									<span className="span-min">{t('content.offers.form.birthday')}</span>
									<MaskedFormControl type='text' name="birthday" id="birthday" 
											value={this.props.state.birthday} disabled={this.props.state.blockFields}
                          					onChange={this.props.dateHandleChange} onKeyPress={(e) => this.props.validate(e)}
                          					mask='11/11/1111' placeholder="dd/mm/yyyy" className="form-control input-date" />
								</div>
								<div className="form-group col-xs-12 col-sm-4" style={{paddingRight: 0,marginBottom: 0}}>
									<span className="span-min">{t('content.offers.form.age')}</span>
									<input className="form-control" name="age" id="age" value={ this.props.state.age } 
						 				onChange={ this.props.handleChange } onKeyPress={(e) => this.props.validate(e)} disabled required/>
								</div>
							</div>
						</div>
						
						<div className="col-md-12" style={{padding:"0px"}}>
							<div className=" col-xs-12 col-sm-4" >
								<span className="span-min">{t('content.offers.form.names')}</span>
								<input className="form-control" id="names" name="names" disabled={this.props.state.blockFields}
									value={ this.props.state.names } onKeyPress={(e) => this.props.validate(e)} 
									onChange={ this.props.handleChange }/>
							</div>

							<div className="col-xs-12 col-sm-2">
					 			<span className="span-min">{t('content.offers.form.lastname1')}</span>
								<input id="lastname1" className="form-control" name="lastname1" 
									value={ this.props.state.lastname1} onChange={ this.props.handleChange }
									disabled={this.props.state.blockFields} onKeyPress={(e) => this.props.validate(e)}/>
							</div>
							<div className="col-xs-12 col-sm-2" >
					 			<span className="span-min">{t('content.offers.form.lastname2')}</span>
								<input className="form-control" name="lastname2" id="lastname2" value={ this.props.state.lastname2 } 
					 				onChange={ this.props.handleChange } disabled={this.props.state.blockFields} 
					 				onKeyPress={(e) => this.props.validate(e)}/>
							</div>
							<div className="col-xs-12 col-sm-4" >
						        <span className="span-min">{t('content.offers.form.email')} </span>
						        <span className="span-min" style={{color:'red'}}>{this.props.state.error_email}</span>
				            	<input className="form-control" id="email" name="email" disabled={this.props.state.blockFields}
				            		placeholder="nombre@example.com"
									value={ this.props.state.email || ""} onChange={ this.props.handleChange } 
									onKeyPress={(e) => this.props.validate(e)}/>
							</div>
							 <div className="col-xs-12 col-sm-4" >
						        <span className="span-min">{t('content.offers.form.scholarship')} </span>
				            	<select className="form-control" name="scholarship" id="scholarship"
						        	value={ this.props.state.scholarship ||""} disabled={this.props.state.blockFields}
						        	onChange={ this.props.selectFieldHandle.bind(null,"id","scholarship") } 
						        	onKeyPress={(e) => this.props.validate(e)} >
						        	<option value="" disabled>Seleccionar...</option>
					                {
					                	this.state.scholarships.map(function(t) {
					                  		return <option  key={t.id}  value={t.key} >{t.name}</option>;
					                	})
					              	}
					            </select>
							</div>
							<div className="col-xs-12 col-sm-4" >
					        	<span className="span-min">{t('content.offers.form.job_profile')}</span>
					            {/*<select className="form-control" id="job_profile" name="job_profile" 
					            	value={ this.props.state.job_profile } disabled={this.props.state.blockFields}
							        onChange={ this.props.selectFieldHandle.bind(null,"id","job_profile") } onKeyPress={(e) => this.props.validate(e)}> 
							        <option value="" disabled>Seleccionar...</option>
					                {
						                this.state.jobProfiles.map(function(t) {
						                  return <option key={t.id}  value={t.key} >{t.name} </option>;
						                })
						            }
				                
				              	</select>*/}
				              	<AsyncTypeahead 
							          /*{...this.state}*/
							          disabled={this.props.state.blockFields}
							          labelKey={(option) => `${option.name}`}
							          minLength={0}
							          id="job_profile" name="job_profile"
							          onKeyPress={(e) => this.props.validate(e)}
							          options={this.state.jobProfiles}
							          onChange={this.handleTypeAheadChange('job_profile')}
							          onSearch={this._handleSearchJob}
							          defaultSelected={this.state.jobProfiles.slice(this.state.indice, 1)}
								      selected={this.state.requestedSelected}
							          ref="_handleSearch_job"
							          useCache={false}	
							          isLoading={this.state.isLoading}
							          delay={600}
							          paginationText="Mostrar mas resultados..."
							    />
							</div>
							
						</div>
				</fieldset>
				
	        </div>
		)
	}
}

export default translate('translations')(PersonData);